import React from "react";
import AppText from "./AppText";
import { UserPasskey } from "../types";

import "./Mfa.css";
import MfaPasskey from "./MfaPasskey";
import AddPasskey from "./AddPasskey";
import Button from "../../presentational/Button";
import { appStrings } from "./strings";
import Links from "./Links";

interface MfaProps {
    serverError: string;
    isLoading: boolean;
    totpEnabled: boolean;
    passkeysEnabled: boolean;
    passkeys: UserPasskey[];
    addPasskey: (refreshOnly: boolean) => void;
    renamePasskey: (passkey: UserPasskey) => void;
    deletePasskey: (id: string) => void;
    addTotp: () => void;
    removeTotp: () => void;
    generateRecoveryCodes: () => void;
}

const Mfa: React.FC<MfaProps> = ({
    serverError,
    isLoading,
    totpEnabled,
    passkeysEnabled,
    passkeys,
    addPasskey,
    renamePasskey,
    deletePasskey,
    addTotp,
    removeTotp,
    generateRecoveryCodes,
}) => {
    function disableTotp() {
        if (confirm(appStrings["mfa-totp-remove-confirm"])) {
            removeTotp();
        }
    }

    return (
        <main className="mfa-settings-page">
            <div className="form-wrapper">
                <form className="form" onSubmit={(e) => e.preventDefault()}>
                    {serverError && <p className="server-error">{serverError}</p>}
                    <div className="form-header">
                        <h2>
                            <AppText textKey="mfa-title" />
                        </h2>
                        <p>
                            <AppText textKey="mfa-info" />
                        </p>
                    </div>
                    {passkeysEnabled &&
                        <div className="mfa-section mfa-passkeys">
                            <div className="mfa-sub-header">
                                <AppText textKey="mfa-passkeys-header" />
                            </div>
                            <div className="mfa-passkey-list">
                                {passkeys &&
                                  passkeys.map((passkey) => (
                                    <MfaPasskey
                                      key={passkey.id}
                                      isLoading={isLoading}
                                      passkey={passkey}
                                      renamePasskey={renamePasskey}
                                      deletePasskey={deletePasskey}
                                    />
                                  ))}
                            </div>
                            <div className="mfa-passkey-add">
                                <AddPasskey
                                  isSubView={true}
                                  serverError={serverError}
                                  isLoading={isLoading}
                                  addPasskey={() => {
                                      addPasskey(true);
                                  }}
                                />
                            </div>
                        </div>
                    }
                    <div className="mfa-section mfa-totp">
                        <div className="mfa-sub-header">
                            <AppText textKey="mfa-totp-header" />
                        </div>
                        {!totpEnabled && (
                            <>
                                <p>
                                    <AppText textKey="mfa-totp-not-enabled-text" />
                                </p>
                                <Button intent="primary" type="button" disabled={isLoading} onClick={addTotp}>
                                    <AppText textKey="mfa-totp-add-label" />
                                </Button>
                            </>
                        )}
                        {totpEnabled && (
                            <>
                                <p>
                                    <AppText textKey="mfa-totp-enabled-text" />
                                </p>
                                <Button intent="danger" type="button" disabled={isLoading} onClick={disableTotp}>
                                    <AppText textKey="mfa-totp-remove-label" />
                                </Button>
                            </>
                        )}
                    </div>
                    {(passkeys?.length || totpEnabled) &&
                        <div className="mfa-section mfa-recovery-codes">
                            <div className="mfa-sub-header">
                                <AppText textKey="mfa-recovery-codes-header" />
                            </div>
                            <p>
                                <AppText textKey="mfa-recovery-codes-info" />
                            </p>
                            <Button intent="primary" type="button" disabled={isLoading} onClick={generateRecoveryCodes}>
                                <AppText textKey="mfa-recovery-codes-generate-label" />
                            </Button>
                        </div>
                    }
                </form>
                <Links />
            </div>
        </main>
    );
};

export default Mfa;
